import { ArrowLeftIcon, CloseIcon } from "@ui-d2c/components/ui/icon";
import type React from "react";

interface ArrowNavProps {
  onClose: () => void;
  onBack: () => void; // New prop for handling the back action
  isVisible: boolean;
  showBackButton: boolean; // New prop to control the visibility of the back button
}

const ArrowNav: React.FC<ArrowNavProps> = ({
  onClose,
  onBack,
  isVisible,
  showBackButton,
}) => (
  <div
    className={`fixed top-0 bottom-0 left-0 z-50 w-16 bg-nav-bg-secondary transition-transform duration-200 ease-in-out ${isVisible ? "translate-x-0" : "-translate-x-[100vw]"}`}
  >
    <button
      className={
        "relative top-6 left-left-custom z-50 m-1 flex h-12 w-12 items-center justify-center rounded-sm text-nav-panel-icon-color transition-all ease-in-out hover:bg-nav-bg-hover lg:left-1"
      }
      onClick={onClose}
    >
      <CloseIcon size="1x" title="Close icon" />
    </button>
    {showBackButton && (
      <button
        className={
          "relative top-16 left-1 z-50 m-1 flex h-12 w-12 items-center justify-center rounded-sm text-nav-panel-icon-color hover:bg-nav-bg-hover"
        }
        onClick={onBack}
      >
        <ArrowLeftIcon size="1x" title="ArrowLeft icon" />
      </button>
    )}
  </div>
);

export { ArrowNav };
